import {ethers} from "ethers";

export function generateCOAHash(collectionAddress: string, tokenID: string, ownerWallet: string) : string{
    let hashInputStr = collectionAddress + tokenID + ownerWallet;
    let generatedCOAHash = ethers.utils.keccak256(ethers.utils.toUtf8Bytes(hashInputStr));
    console.debug(`${hashInputStr} => ${generatedCOAHash}`);
    return generatedCOAHash.slice(2, 18);
}
